import { Button, Link } from "@at/design-system-elements";
import { ThemeSelectors, TypeSmart } from "@at/design-system-foundation";
import { Banner } from "@at/design-system-patterns";
import styled from "styled-components";

import { PrintStyleSheet } from "../../seller/advert-seller-details/location/location.styles";

export const LeasingProductBordered = styled.div<{
  showError?: boolean;
}>`
  border-radius: 5px;
  border: 1px solid
    ${({ theme, showError = false }) =>
      showError
        ? ThemeSelectors.getErrorColor(theme)
        : ThemeSelectors.getDarkGrey(theme)};
  padding: ${({ theme }) => ThemeSelectors.getGroupFiveSpacing(theme)};
  margin-bottom: ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)};
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)};

  &.hide-print {
    ${PrintStyleSheet}
  }
`;

export const LeasingProductToggleArea = styled.div`
  display: flex;
  align-items: center;
  ${PrintStyleSheet}

  & > div:first-child {
    width: 100%;
    margin-right: ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)};
  }

  input:disabled {
    + label {
      color: #d1d0cf;
      cursor: not-allowed;
    }
  }
`;

export const LeasingProductToggleInfo = styled(Button)`
  padding: 0;
  height: 24px;

  &:hover:not(:disabled) {
    background: none;
  }
`;

export const LeasingProductCustomiseVehicleFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)};
`;

export const LeasingProductCustomisePaymentFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => ThemeSelectors.getGroupFiveSpacing(theme)};
`;

export const LeasingProductFormField = styled.div``;

export const LeasingBusinessTypeInfo = styled(TypeSmart).attrs({ as: "p" })`
  margin-top: ${({ theme }) => ThemeSelectors.getGroupTwoSpacing(theme)};
`;

export const LeasingBusinessTypeInfoBanner = styled(Banner)`
  margin-top: ${({ theme }) => ThemeSelectors.getGroupTwoSpacing(theme)};
`;

export const Weight500 = styled.span`
  font-variation-settings: "wght" 500;
`;

export const StockBannerTitle = styled.span`
  display: block;
  font-variation-settings: "wght" 500;
  margin-bottom: ${({ theme }) => ThemeSelectors.getGroupTwoSpacing(theme)};
`;

export const StockBanner = styled(Banner)`
  margin-bottom: 0;
  animation: none;
  @media print {
    border: 1px solid ${({ theme }) => ThemeSelectors.getGrey(theme)};
  }
`;

export const FindAlternativeStockContainer = styled.div`
  margin-top: ${({ theme }) => ThemeSelectors.getGroupFiveSpacing(theme)};
`;

export const LinkContainer = styled(Link)`
  margin-top: ${({ theme }) => ThemeSelectors.getGroupTwoSpacing(theme)};
`;

export const TermFilterReset = styled(Button)`
  display: inline-flex;
  align-items: center;
  padding: 0;
  margin-top: ${({ theme }) => ThemeSelectors.getGroupTwoSpacing(theme)};
  width: fit-content;
  ${PrintStyleSheet}

  &:visited {
    svg {
      fill: ${({ theme }) => ThemeSelectors.getVisitedColor(theme)};
    }
  }

  &:hover:not(:disabled) {
    background: none;
  }
`;
